import clsx from 'clsx';
import useTranslation from 'next-translate/useTranslation';
import setLanguage from 'next-translate/setLanguage';

// Lib
import { platform_language } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

// Component
import Dropdown, { BaseItem, NO_BACKGROUND_BLACK } from '@/components/base/Dropdown';

// Type
import type { DropdownBaseButtonProps } from '@/components/base/Dropdown';

const SwitchLanguage = ({ buttonStyle }: DropdownBaseButtonProps) => {
    const { t } = useTranslation();
    const { lang } = useTranslation();

    return (
        <Dropdown
            button={
                <Dropdown.BaseButton buttonStyle={buttonStyle}>
                    <span
                        className={clsx('uppercase', {
                            underline: buttonStyle === NO_BACKGROUND_BLACK
                        })}>
                        {lang}
                    </span>
                </Dropdown.BaseButton>
            }
            size="sm">
            {platform_language(t).map((language) => {
                return (
                    <Dropdown.Item
                        key={language.value}
                        onClick={async () => setLanguage(language.value)}>
                        {({ active }) => (
                            <BaseItem active={active}>
                                <span
                                    className={clsx('test uppercase', {
                                        'font-GBold text-icoBlue': lang === language.value
                                    })}>
                                    {language.value}
                                </span>
                            </BaseItem>
                        )}
                    </Dropdown.Item>
                );
            })}
        </Dropdown>
    );
};

export default SwitchLanguage;
